import React, { useState, useEffect } from "react";
import "./LocationModal.css";
import { MdMyLocation } from "react-icons/md";
import { FaSearchLocation } from "react-icons/fa";

const recentDefaults = [
    "Mumbai, India",
    "Vipin Garden Extension, Laxmi Vihar",
    "Noida, India",
    "Sector 18, Noida, Uttar Pradesh, India"
];

const LocationModal = ({ isOpen, onClose, onSelectLocation }) => {
    const [recentLocations, setRecentLocations] = useState([]);

    useEffect(() => {
        try {
            const stored = JSON.parse(localStorage.getItem("recentLocations"));
            setRecentLocations(Array.isArray(stored) ? stored : recentDefaults);
        } catch (err) {
            setRecentLocations(recentDefaults);
        }
    }, []);

    const updateRecentLocations = (newLocation) => {
        if (typeof newLocation !== "string") return;

        const updated = [
            newLocation,
            ...recentLocations.filter((l) => l !== newLocation)
        ].slice(0, 5);

        setRecentLocations(updated);
        localStorage.setItem("recentLocations", JSON.stringify(updated));
    };

    const getAddressFromLatLng = async (lat, lng) => {
        const apiKey = 'AIzaSyDJU4XzSrUxnEMVk2a7eplTA4spBU3qdO8';
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

        try {
            const response = await fetch(url);

            console.log("Geocoding response:", response);
            const data = await response.json();

            console.log("Geocoding data:", data);

            if (data.status === "OK" && data.results[0]?.formatted_address) {
                return data.results[0].formatted_address;
            } else {
                console.error("Geocoding failed:", data.status);
                return null;
            }
        } catch (error) {
            console.error("Error fetching geocode data:", error);
            return null;
        }
    };

    const handleDetectLocation = async () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(async (position) => {
                const { latitude, longitude } = position.coords;

                const address = await getAddressFromLatLng(latitude, longitude);
                console.log("Geocoded address:", address);

                if (address) {
                    onSelectLocation(address); 
                    updateRecentLocations(address);
                    onClose(); 
                } else {
                    alert("Failed to detect address from location.");
                }
            });
        } else {
            alert("Geolocation not supported");
        }
    };


    return (
        <div className="pw-location-modal-backdrop">
            <div className="pw-location-modal-container">
                <div className="pw-location-modal-header">
                    <h3>Select Your Location</h3>
                    <button onClick={onClose} className="pw-location-modal-close">
                        ✖
                    </button>
                </div>

                <div className="pw-location-modal-body">
                    <div className="pw-location-detect">
                        <button
                            onClick={handleDetectLocation}
                            className="pw-location-detect-btn"
                        >
                            <MdMyLocation /> Detect current location
                        </button>
                        <span>Using GPS</span>
                    </div>

                    <h4 className="pw-location-modal-subheading">Recent Locations</h4>
                    <ul className="pw-location-list">
                        {recentLocations.map((loc, idx) =>
                            typeof loc === "string" ? (
                                <li
                                    key={idx}
                                    className="pw-location-item"
                                    onClick={() => {
                                        onSelectLocation(loc);
                                        updateRecentLocations(loc);
                                        onClose();
                                    }}
                                >
                                    <FaSearchLocation /> {loc.length > 50 ? loc.slice(0, 50) + "..." : loc}
                                </li>
                            ) : null
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default LocationModal;
